import { useTranslation } from 'react-i18next';
import { Fragment, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'entities/Auth';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/react/20/solid';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoClose } from 'react-icons/io5';
import _ from 'lodash';
import { AFRICA_SAFARI_LIGHT_LOGOS, TANZANIA_SPECIALIST_LIGHT_LOGOS } from 'utils/constants';
import NavigationLink from './NavigationLink';
import LanguageSelector from 'components/LanguageSelector';
import MobileNavigation from 'components/MobileNavigation';
import { URLS } from 'config/urls';
import { FlightTakeoffIcon } from '@/assets/icons/FlightTakeoffIcon';
import { TornEdge } from './torn-edge';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const tanzaniaSpecialistLightLogo = useMemo(() => {
    return _.get(TANZANIA_SPECIALIST_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  const africaSafariLightLogo = useMemo(() => {
    return _.get(AFRICA_SAFARI_LIGHT_LOGOS, i18n.language);
  }, [i18n.language]);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
      navigate(URLS.LOGIN);
    } catch (error) {
      // TODO: Show error to the user
      console.error('Failed to logout', error);
    }
  }, [logout, navigate]);

  return (
    <Fragment>
      <div className='relative z-[1] flex h-[var(--navigation-height)] w-full justify-center bg-brand-brown'>
        <div className='h-full w-full max-w-[1440px] px-[24px]'>
          <div className='flex h-full items-center justify-between'>
            <div className='flex h-6 items-center gap-2 md:h-10 md:gap-[30px]'>
              <img
                src={tanzaniaSpecialistLightLogo}
                alt='Tanzania Specialist Logo'
                className='h-full w-auto object-contain'
              />
              <img src={africaSafariLightLogo} alt='Africa Safari Logo' className='h-full w-auto object-contain' />
            </div>
            <div className='flex gap-[24px] items-center max-md:hidden'>
              <NavigationLink
                className='group flex flex-row items-center gap-2 rounded-md p-3 hover:bg-muted'
                href={URLS.FLIGHTS}
              >
                <FlightTakeoffIcon className='h-6 w-6 text-white group-hover:text-brand-brown group-[.active]:text-brand-brown' />
                {t('navigation.flights')}
              </NavigationLink>
              <button
                onClick={handleLogout}
                className='group flex flex-row items-center gap-2 rounded-md p-3 text-white font-[MuseoSans900] tracking-[1.5px] normal-case cursor-pointer hover:bg-muted hover:text-brand-brown'
              >
                <ArrowRightStartOnRectangleIcon className='h-6 w-6 text-white group-hover:fill-brand-brown' />
                {t('navigation.logout')}
              </button>
              <LanguageSelector
                hoverStyle='hover:bg-muted p-3 rounded-md'
                chevronClassName='text-white group-hover:text-brand-brown group-data-[popup-open]:text-brand-brown'
              />
            </div>
            <MobileNavigation
              openIcon={<GiHamburgerMenu className='size-6 text-white' />}
              closeIcon={<IoClose className='h-6 w-6 text-white' />}
              handleLogout={handleLogout}
            />
          </div>
        </div>
        <TornEdge />
      </div>
    </Fragment>
  );
};

export default Navigation;
